export default {
  data() {
    return {
      countdown: 0,
      countdownTimer: null
    }
  },
  computed: {
    confirmButtonText() {
      return this.countdown > 0 ? `确认（${this.countdown}s）` : '确认'
    },
    isSubmitDisabled() {
      return this.isLoading || this.countdown > 0
    }
  },
  beforeDestroy() {
    this.clearCountdownTimer()
  },
  methods: {
    startCountdown(seconds = 3) {
      this.clearCountdownTimer()
      this.countdown = seconds
      this.countdownTimer = setInterval(() => {
        if (this.countdown <= 1) {
          this.clearCountdownTimer()
          return
        }
        this.countdown -= 1
      }, 1000)
    },
    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      this.countdown = 0
    }
  }
}

